import { useState } from "react";
import { useInView } from "react-intersection-observer";
import { useGetAllAdvertisesAsAdminQuery } from "../../../lib/apollo/graphql/generated";

function useAdsList() {
  const { ref: fetchMoreRef } = useInView({
    threshold: 0.2,
    onChange: onEndReached,
  });

  const [fetchingMore, setFetchingMore] = useState(false);

  const [showNewRow, setShowNewRow] = useState(false);

  const { loading, data, fetchMore } = useGetAllAdvertisesAsAdminQuery({
    variables: {
      first: 10,
    },
  });

  function toggleShowNewRow(value: boolean) {
    setShowNewRow(value);
  }

  function onEndReached(inView: boolean) {
    if (
      inView &&
      !fetchingMore &&
      data?.getAllAdvertisesAsAdmin?.pageInfo?.hasNextPage
    ) {
      setFetchingMore(true);

      fetchMore({
        variables: {
          first: 10,
          after: data?.getAllAdvertisesAsAdmin?.pageInfo?.endCursor,
        },
      }).finally(() => {
        setFetchingMore(false);
      });
    }
  }

  return {
    refs: {
      fetchMoreRef,
    },
    models: {
      loading,
      data: data?.getAllAdvertisesAsAdmin?.edges,
      showNewRow,
    },
    operations: {
      toggleShowNewRow,
    },
  };
}

export default useAdsList;
